import { DeliveryModel } from '@audibene/ta.utils-opportunity'

const PartnerPortalDeliveryModel = {
  [DeliveryModel.TELEAUDIOLOGY]: DeliveryModel.TELEAUDIOLOGY,
  [DeliveryModel.TA_LIGHT]: DeliveryModel.TA_LIGHT,
  [DeliveryModel.NETWORK]: DeliveryModel.NETWORK,
} as const

type PartnerPortalDeliveryModel = typeof PartnerPortalDeliveryModel[keyof typeof PartnerPortalDeliveryModel]

export { PartnerPortalDeliveryModel }
